module.exports = __webpack_public_path__ + "img/1537828317.5fb7061e.jpg";